/**
 * y-websocket: status «connected» ≠ документ уже с сервера.
 * Писать в Y.Doc до sync — типичный способ затереть чужой код.
 */
export function whenYjsSynced(provider, callback) {
  let done = false;
  const fire = () => {
    if (done) return;
    done = true;
    callback();
  };
  if (provider.synced) {
    fire();
    return () => {};
  }
  const handler = (synced) => {
    if (synced !== false) fire();
  };
  provider.on('sync', handler);
  return () => {
    provider.off('sync', handler);
  };
}
